import React, { useEffect, useState } from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const LinearProgressDarkStyles = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "transparent",
    // opacity: 0
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
}));

export const LinearProgressDark = () => (
  <LinearProgressDarkStyles sx={{ borderRadius: "100px", width: "98%", marginBottom: "0.1rem" }} />
)